import { DataTableColumnHeader } from "@components/ui/data-table/DataTableColumnHeader";
import { createColumn } from "@/lib/table/columnFactory";
import { TicketStatusBadge } from "../components/shared/TicketStatusBadge";
import type { Ticket, TicketColumnSettings } from "./types";

export const statusColumnFactory = (settings: TicketColumnSettings) =>
  createColumn<Ticket>({
    id: "status",
    accessorKey: "status",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Statut" />,
    cell: ({ row }) => <TicketStatusBadge status={row.original.status} size={settings.badgeSize} />,
    size: settings.colWidth.badge,
  });
